import environment from "src/utils/environment";

export default function downloadFile(url, destination) {
  if (environment.isBrowser) {
    window.location.href = url;
    return;
  }
  const fs = window.require("fs");
  const request = window.require("request");
  return new Promise((resolve, reject) => {
    const file = fs.createWriteStream(destination);
    const sendReq = request.get(url);

    sendReq.on("response", (response) => {
      if (response.statusCode !== 200) {
        return reject("Response status was " + response.statusCode);
      }

      sendReq.pipe(file);
    });

    file.on("finish", resolve);

    sendReq.on("error", (err) => {
      fs.unlink(destination, () => {});
      return reject(err.message);
    });

    file.on("error", (err) => {
      fs.unlink(destination, () => {});
      return reject(err.message);
    });
  });
}
